const filterAppearancesByEdition = (appearances, editionId) => {
  if (!Array.isArray(appearances)) {
    return [];
  }

  if (!editionId) {
    return appearances;
  }

  return appearances.filter(
    (appearance) =>
      appearance?.fieldEdition?.id &&
      String(appearance.fieldEdition.id) === String(editionId)
  );
};

export default filterAppearancesByEdition;
